// VobHome.js — the VOBs menu item. Two screens:
//   VOB work queue   the first page: only people a VOB was asked for, with status, next step and who has it. Opening one shows the verification workspace.
//   Requests         the earlier screen: VOB requests sent out and what came back. Kept until the in-house callers start.
// A lead can send someone straight here on its client: it leaves the lead's id in tcio_vob_open_lead and fires tcio:open-vob (VobJump listens).
import React, { useState, useEffect } from 'react';
import { tokens as tk } from '../theme';
import VOBs from '../VOBs';
import VobWorkspace from './VobWorkspace';
import VobQueue from './VobQueue';

const KEY = 'tcio_vob_open_lead';
const take = () => { try { const v = localStorage.getItem(KEY); if (v) localStorage.removeItem(KEY); return v || null; } catch (e) { return null; } };

// mounted once by the app shell: turns "open the VOB" from any screen into a move to the VOBs menu item
export function VobJump({ go }) {
  useEffect(() => { const h = () => { if (typeof go === 'function') go('vobs'); }; window.addEventListener('tcio:open-vob', h); return () => window.removeEventListener('tcio:open-vob', h); }, [go]);
  return null;
}

export default function VobHome({ user }) {
  const [jump] = useState(take);
  const [openLead, setOpenLead] = useState(jump);
  const [note, setNote] = useState(null);
  const [view, setView] = useState(() => { if (jump) return 'workspace'; try { return localStorage.getItem('tcio_vob_view') || 'workspace'; } catch (e) { return 'workspace'; } });
  useEffect(() => { const h = () => { const v = take(); if (v) { setOpenLead(v); setView('workspace'); } }; window.addEventListener('tcio:open-vob', h); return () => window.removeEventListener('tcio:open-vob', h); }, []);
  const pick = (v) => { setView(v); setOpenLead(null); try { localStorage.setItem('tcio_vob_view', v); } catch (e) { /* storage unavailable */ } };
  const seg = (k, label) => <button key={k} onClick={() => pick(k)} style={{ padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: tk.font, borderRadius: tk.radiusControl, border: `1px solid ${view === k ? tk.ai : tk.border}`, background: view === k ? tk.ai : tk.surface, color: view === k ? '#fff' : tk.ink }}>{label}</button>;
  return (<div>
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', padding: '14px 22px 0' }}>{seg('workspace', 'VOB work queue')}{seg('requests', 'Requests')}</div>
    {view !== 'workspace' ? <VOBs user={user} />
      : openLead ? <VobWorkspace key={openLead} user={user} openLead={openLead} onBack={(why) => { setNote(typeof why === 'string' ? why : null); setOpenLead(null); }} />
        : <VobQueue user={user} note={note} onOpen={(id) => { setNote(null); setOpenLead(id); }} />}
  </div>);
}
